/**
 * Enumeration for possible password status.
 *
 * @readonly
 * @enum {string}
 */
export const PasswordStatus = Object.freeze({
    EXPIRED: 'EXPIRED',
    INITIALIZED: 'INITIALIZED',
    RESET: 'RESET',
    VALID: 'VALID'
})
